module.exports = __webpack_public_path__ + "img/everyone_my account.b1df9e12.svg";